(() => {
  'use strict';

  // Prevent multiple initializations
  if (window.ProductZoomModal) {
    return;
  }


class ProductZoomModal {
  constructor() {
    this.modal = null;
    this.currentImageIndex = 0;
    this.images = [];
    this.isZoomed = false;
    this.defaultZoom = 1.35;
    this.zoomLevel = this.defaultZoom;
    this.minZoom = 1;
    this.maxZoom = 3;
    this.isDragging = false;
    this.isPinching = false;
    this.startX = 0;
    this.startY = 0;
    this.translateX = 0;
    this.translateY = 0;
    this.pinchStartDistance = 0;
    this.pinchStartZoom = this.zoomLevel;
    this.init();
  }

  init() {
    this.createModal();
    this.bindEvents();
  }

  createModal() {
    const modalHTML = `
      <div class="product-zoom-modal" id="productZoomModal">
        <div class="product-zoom-modal__content">
          <div class="product-zoom-modal__header">
            <button class="product-zoom-modal__close" aria-label="Close zoom modal">
              <svg viewBox="0 0 24 24">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="product-zoom-modal__main">
            <div class="product-zoom-modal__image-container">
              <div class="product-zoom-modal__loading">
                <svg class="spinner" viewBox="0 0 66 66">
                  <circle class="path" fill="none" stroke="#333" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
              <button class="product-zoom-modal__nav product-zoom-modal__nav--prev carousel__nav-button carousel__nav-button--prev" type="button" name="previous" aria-label="Previous image">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M7 13L1 7L7 1" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" stroke-linejoin="round"></path>
                </svg>
              </button>
              <button class="product-zoom-modal__nav product-zoom-modal__nav--next carousel__nav-button carousel__nav-button--next" type="button" name="next" aria-label="Next image">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M1 1L7 7L0.999998 13" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" stroke-linejoin="round"></path>
                </svg>
              </button>
              <img class="product-zoom-modal__image" src="" alt="" />
            </div>
            <div class="product-zoom-modal__thumbnails"></div>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('productZoomModal');
    this.imageContainer = this.modal.querySelector('.product-zoom-modal__image-container');
    this.mainImage = this.modal.querySelector('.product-zoom-modal__image');
    this.thumbnailsContainer = this.modal.querySelector('.product-zoom-modal__thumbnails');
    this.loadingSpinner = this.modal.querySelector('.product-zoom-modal__loading');
    this.prevBtn = this.modal.querySelector('.product-zoom-modal__nav--prev');
    this.nextBtn = this.modal.querySelector('.product-zoom-modal__nav--next');
    
  }

  bindEvents() {
    const closeBtn = this.modal.querySelector('.product-zoom-modal__close');
    closeBtn.addEventListener('click', () => this.close());

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });

    this.prevBtn.addEventListener('click', () => {
      this.showImage(this.currentImageIndex - 1);
    });

    this.nextBtn.addEventListener('click', () => {
      this.showImage(this.currentImageIndex + 1);
    });

    document.addEventListener('keydown', (e) => {
      if (!this.modal.classList.contains('active')) return;
      
      switch(e.key) {
        case 'Escape':
          this.close();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          this.showImage(this.currentImageIndex - 1);
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.showImage(this.currentImageIndex + 1);
          break;
      }
    });

    this.bindImageEvents();
  }

  bindImageEvents() {
    this.imageContainer.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.imageContainer.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.imageContainer.addEventListener('mouseup', this.handleMouseUp.bind(this));
    this.imageContainer.addEventListener('mouseleave', this.handleMouseUp.bind(this));

    this.imageContainer.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
    this.imageContainer.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
    this.imageContainer.addEventListener('touchend', this.handleTouchEnd.bind(this));
    this.imageContainer.addEventListener('touchcancel', this.handleTouchEnd.bind(this));

    this.mainImage.addEventListener('load', () => {
      this.loadingSpinner.style.display = 'none';
      this.resetImagePosition();
    });

    this.mainImage.addEventListener('dragstart', (e) => e.preventDefault());
  }

  handleMouseDown(e) {
    if (!this.isZoomed) return;
    this.isDragging = true;
    this.startX = e.clientX - this.translateX;
    this.startY = e.clientY - this.translateY;
    this.imageContainer.style.cursor = 'move';
  }

  handleMouseMove(e) {
    if (!this.isDragging || !this.isZoomed) return;
    e.preventDefault();
    this.translateX = e.clientX - this.startX;
    this.translateY = e.clientY - this.startY;
    this.updateImageTransform();
  }

  handleMouseUp() {
    this.isDragging = false;
    this.imageContainer.style.cursor = this.isZoomed ? 'move' : 'default';
  }

  handleTouchStart(e) {
    if (e.touches.length === 2) {
      this.isPinching = true;
      this.isDragging = false;
      this.pinchStartDistance = this.getTouchDistance(e.touches[0], e.touches[1]);
      this.pinchStartZoom = this.zoomLevel;
      return;
    }

    if (!this.isZoomed || e.touches.length !== 1) return;
    const touch = e.touches[0];
    this.isDragging = true;
    this.startX = touch.clientX - this.translateX;
    this.startY = touch.clientY - this.translateY;
  }

  handleTouchMove(e) {
    if (this.isPinching && e.touches.length === 2) {
      e.preventDefault();
      const distance = this.getTouchDistance(e.touches[0], e.touches[1]);
      const scale = distance / this.pinchStartDistance;
      const nextZoom = this.clampZoom(this.pinchStartZoom * scale);
      this.zoomLevel = nextZoom;
      this.isZoomed = this.zoomLevel > this.minZoom;

      if (!this.isZoomed) {
        this.translateX = 0;
        this.translateY = 0;
      }

      this.updateImageTransform();
      return;
    }

    if (!this.isDragging || !this.isZoomed || e.touches.length !== 1) return;
    e.preventDefault();
    const touch = e.touches[0];
    this.translateX = touch.clientX - this.startX;
    this.translateY = touch.clientY - this.startY;
    this.updateImageTransform();
  }

  handleTouchEnd() {
    this.isDragging = false;
    this.isPinching = false;
  }

  updateImageTransform() {
    const maxTranslateX = (this.mainImage.offsetWidth * (this.zoomLevel - 1)) / 2;
    const maxTranslateY = (this.mainImage.offsetHeight * (this.zoomLevel - 1)) / 2;
    
    this.translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, this.translateX));
    this.translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, this.translateY));
    
    this.mainImage.style.transform = `scale(${this.zoomLevel}) translate(${this.translateX / this.zoomLevel}px, ${this.translateY / this.zoomLevel}px)`;
    this.syncZoomState();
  }

  resetImagePosition() {
    this.zoomLevel = this.defaultZoom;
    this.isZoomed = this.zoomLevel > this.minZoom;
    this.translateX = 0;
    this.translateY = 0;
    this.mainImage.style.transform = `scale(${this.zoomLevel})`;
    this.syncZoomState();
  }

  open(images, startIndex = 0) {
    this.images = images;
    this.currentImageIndex = startIndex;
    this.showImage(startIndex);
    this.createThumbnails();
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
    this.isZoomed = false;
    this.zoomLevel = this.defaultZoom;
    this.translateX = 0;
    this.translateY = 0;
    this.syncZoomState();
  }

  showImage(index) {
    if (index < 0 || index >= this.images.length) return;
    
    this.currentImageIndex = index;
    this.loadingSpinner.style.display = 'block';
    this.mainImage.src = this.images[index].src;
    this.mainImage.alt = this.images[index].alt || '';
    
    // Update navigation button states
    this.prevBtn.disabled = index === 0;
    this.nextBtn.disabled = index === this.images.length - 1;
    
    this.updateActiveThumbnail();
  }

  createThumbnails() {
    this.thumbnailsContainer.innerHTML = '';
    
    this.images.forEach((image, index) => {
      const thumbnail = document.createElement('div');
      thumbnail.className = 'product-zoom-modal__thumbnail';
      if (index === this.currentImageIndex) {
        thumbnail.classList.add('active');
      }
      
      thumbnail.innerHTML = `<img src="${image.thumb}" alt="${image.alt || ''}" />`;
      thumbnail.addEventListener('click', () => this.showImage(index));
      
      this.thumbnailsContainer.appendChild(thumbnail);
    });
  }

  updateActiveThumbnail() {
    const thumbnails = this.thumbnailsContainer.querySelectorAll('.product-zoom-modal__thumbnail');
    thumbnails.forEach((thumb, index) => {
      thumb.classList.toggle('active', index === this.currentImageIndex);
    });
  }

  syncZoomState() {
    if (this.isZoomed) {
      this.imageContainer.classList.add('zoomed');
      this.imageContainer.style.cursor = 'move';
    } else {
      this.imageContainer.classList.remove('zoomed');
      this.imageContainer.style.cursor = 'default';
    }
  }

  clampZoom(value) {
    return Math.min(this.maxZoom, Math.max(this.minZoom, value));
  }

  getTouchDistance(touch1, touch2) {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.hypot(dx, dy);
  }
}

class ProductZoomTrigger {
  constructor() {
    this.zoomModal = new ProductZoomModal();
    this.init();
  }

  init() {
    this.bindTriggers();
  }

  bindTriggers() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.product__media-icon--lightbox');
      if (!trigger) return;
      
      
      e.preventDefault();
      e.stopPropagation();
      
      const mediaContainer = trigger.closest('.product-media-container');
      if (!mediaContainer) {
        console.warn('ProductZoomTrigger: No media container found');
        return;
      }
      
      const currentImage = mediaContainer.querySelector('img');
      if (!currentImage) {
        console.warn('ProductZoomTrigger: No image found in media container');
        return;
      }
      
      this.openZoomModal(currentImage);
    });
  }

  openZoomModal(clickedImage) {
    const productMediaWrapper = document.querySelector('.product__media-wrapper');
    if (!productMediaWrapper) {
      console.warn('ProductZoomTrigger: No product media wrapper found');
      return;
    }
    
    // Get all image media containers
    const imageContainers = Array.from(productMediaWrapper.querySelectorAll('.product-media-container'))
      .filter(container => container.classList.contains('media-type-image'));
    
    
    const allImages = imageContainers.map(container => {
      const img = container.querySelector('img');
      return img ? {
        src: this.getHighResImageUrl(img.src),
        thumb: this.getThumbnailUrl(img.src),
        alt: img.alt || ''
      } : null;
    }).filter(Boolean);
    
    
    // Find the index of the clicked image
    const clickedContainer = clickedImage.closest('.product-media-container');
    const startIndex = imageContainers.indexOf(clickedContainer);
    
    
    if (allImages.length > 0) {
      this.zoomModal.open(allImages, Math.max(0, startIndex));
    } else {
      console.warn('ProductZoomTrigger: No images found to display');
    }
  }

  getHighResImageUrl(src) {
    if (!src) return src;
    
    // Handle Shopify CDN URLs
    if (src.includes('cdn.shopify.com')) {
      return src.replace(/(_\d+x\d*)?(\?|$)/, '_2048x$2');
    }
    
    // Handle other image URLs
    return src.replace(/(_\d+x\d*)?(\.[^.?]+)(\?.*)?$/, '_2048x$2$3');
  }

  getThumbnailUrl(src) {
    if (!src) return src;
    
    // Handle Shopify CDN URLs  
    if (src.includes('cdn.shopify.com')) {
      return src.replace(/(_\d+x\d*)?(\?|$)/, '_200x$2');
    }
    
    // Handle other image URLs
    return src.replace(/(_\d+x\d*)?(\.[^.?]+)(\?.*)?$/, '_200x$2$3');
  }
}


window.ProductZoomModal = ProductZoomModal;
window.ProductZoomTrigger = ProductZoomTrigger;

// Auto-initialise on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.productZoomTriggerInstance) {
      window.productZoomTriggerInstance = new ProductZoomTrigger();
    }
  });
} else {
  if (!window.productZoomTriggerInstance) {
    window.productZoomTriggerInstance = new ProductZoomTrigger();
  }
}

})();
